import React from 'react'
import ReactDOM from 'react-dom';

import {takeEvery} from 'redux-saga/effects';
import {put, select} from 'redux-saga/effects'
import * as actions from '../actions/index';
import * as actionTypes from '../actions/actionTypes';

//Components
import Notification from '../../components/Notifications/Notifications';

//Utils
import qs from 'qs';
import axios from '../../services/axios-client';

export function* getServices() {
    try {
        const services = yield select(state => state.booking.serviceCategories);
        if (services) {
            return
        }

        const shopID = yield select(state => state.companies.shopId);
        const companyAPIKey = yield select(state => state.auth.companyKey);
        const locale = yield select(state => state.locales.locale);

        const data = {
            'shop_id': shopID
        };
        const response = yield axios.request({
            data: qs.stringify(data),
            method: 'post',
            url: '/api/company/shop/categories/list',
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                'company-api-key': companyAPIKey,
                'locale': locale
            },
        });

        const categories = Object.keys(response.data.result).reduce((categories, name) => {
            const services = response.data.result[name].filter(({type}) => type !== 'never_and_hidden');
            return services.length === 0 ? categories : {
                ...categories,
                [name]: services
            };
        }, {});

        yield put(actions.getServicesSucceeded(categories))
    } catch (error) {
        ReactDOM.render(
            <Notification type='error' error={error}/>,
            document.getElementById('notification')
        );
    }
}

export function* getProductList(action) {
    try {
        yield put(actions.getProductListSucceeded(null));
        const userToken = yield select(state => state.auth.userToken);
        const companyKey = yield select(state => state.auth.companyKey);
        const shopId = yield select(state => state.companies.shopId);
        const data = {
            'service_id': action.serviceId,
            'type': action.productType,
            'shop_id': shopId,
        };
        const response = yield axios.request({
            data: qs.stringify(data),
            method: 'post',
            url: '/api/booking/product/list',
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                'company-api-key': companyKey,
                'user-access-token': userToken
            },
        });
        yield put(actions.getProductListSucceeded(response.data.result))
    } catch (error) {
        if(error.response && error.response.data && error.response.data.result && error.response.data.result.message) {
            const {message} = error.response.data.result;
            yield put(actions.getProductListFailed(message));
            return;
        }

        ReactDOM.render(
            <Notification type='error' error={error}/>,
            document.getElementById('notification')
        );
    }
}

export function* getAvailableTime(action) {
    try {
        yield put(actions.getAvailableTimeSucceeded(null, null));
        const userToken = yield select(state => state.auth.userToken);
        const companyKey = yield select(state => state.auth.companyKey);
        const data = {
            'service_id': action.serviceId,
            'room_id': action.roomId,
            'timestamp': action.timestamp
        };
        const response = yield axios.request({
            data: qs.stringify(data),
            method: 'post',
            url: '/api/booking/product/available-time/get',
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                'company-api-key': companyKey,
                'user-access-token': userToken
            },
        });
        yield put(actions.getAvailableTimeSucceeded(response.data.result.slots, action.roomId));
    } catch (error) {
        ReactDOM.render(
            <Notification type='error' error={error}/>,
            document.getElementById('notification')
        );
    }
}

export const watchBooking = [
    takeEvery(actionTypes.GET_SERVICES, getServices),
    takeEvery(actionTypes.GET_PRODUCT_LIST, getProductList),
    takeEvery(actionTypes.GET_AVAILABLE_TIME, getAvailableTime),
];